// extracted by mini-css-extract-plugin
export default {"textView":"teacher-note-view_textView__jbIKy","tagLine":"teacher-note-view_tagLine__76pGK"};